<template>
    <v-card>
        <v-snackbar v-model="snackbar" color="success" :timeout="servicesData.timeout" top>
            {{servicesData.message}}
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                Table Order
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-row>
                        <v-col>
                            <v-list>
                                <draggable
                                        v-model="relsFiltered"
                                        element="div"
                                        @start="drag = true"
                                        @end="drag = false">
                                    <div
                                            v-for="(el, index) in headers"
                                            @click="onSelect(el)"
                                            :key="el.id"
                                    >
                                        <v-divider v-if="index === 0"/>

                                        <v-card
                                                class="order-item"
                                                :key="el.id"
                                                ripple
                                        >
                                            <v-list-tile-content>
                                                <v-list-tile-title color="blue" dark>
                                                    {{index+1}}. {{el.headerName}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-card>

                                        <v-divider/>
                                    </div>
                                </draggable>
                            </v-list>
                        </v-col>
                    </v-row>
                </form>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-row justify="center">
                <v-btn color="primary" @click="orderSubmit">Submit</v-btn>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import draggable from "vuedraggable";

    export default {
        name: "OrderModel",
        watch: {},
        components: {draggable},
        data() {
            return {
            reportID:this.$route.params.id,
                snackbar: false,
                panel: [0, 1],
                formData: {
                    activeHeader: [],
                    activeSection: [],
                },
                getSectionList: {
                    list: []
                },
                headers: [],
                headerID: [],
                subSectionID: [],
                headerData: [],
                servicesData: {
                    data: {},
                    message: "",
                    color: "",
                    timeout: 4000
                }
            };
        },
        computed: {
            relsFiltered: {
                get() {
                    return this.headers;
                },
                set(data) {
                    this.headers = data;
                }
            }
        },
        destroyed() {
        },
        mounted() {
            this.formOption();
        },
        methods: {
            orderSubmit() {
                this.relsFiltered.forEach((response, index) => {
                    response.orderID = index + 1
                })
                let postData = {
                    reportID: parseInt(this.reportID),
                    headerOrderList: this.relsFiltered
                }
                axios.post("ReportSettings/InsertUpdateReportHeaderOrder", postData).then(response => {
                    console.log(response.data)
                    this.snackbar = true
                    this.servicesData.message = "Budget order updated successfully"
                })
            },
            updatedCheckHeader(id, status) {
                if (status) {
                    this.headerID.push(id)
                } else {
                    this.headerID.splice(this.headerID.indexOf(id), 1);
                }
                console.log(id, this.headerID)
            },
            updatedCheckSection(id, status) {
                if (status) {
                    this.subSectionID.push(id)
                } else {
                    this.subSectionID.splice(this.subSectionID.indexOf(id), 1);
                }
                console.log(id, this.subSectionID)
            },
            tableHeaderSubmit() {
                let postData = {
                    reportID: parseInt(this.reportID),
                    ReportHeadersList: this.headerID
                }
                axios.post("ReportSettings/ReportColumnMappingUpdateAsync", postData).then(response => {
                    this.getHeaderOrder()
                    console.log(response)
                    this.snackbar = true
                    this.servicesData.message = "Column visibility updated successfully"
                })
            },

            getHeaderOrder() {

                axios.get('ReportSettings/GetReportHeaderWithOrderByIDAsync', {
                    params: {
                        ReportID: parseInt(this.reportID)
                    }
                }).then(response => {
                    this.headers = response.data
                })

            },
            tableSectionSubmit() {
                let postData = {
                    reportID: parseInt(this.reportID),
                    SubSectionList: this.subSectionID
                }
                axios.post("ReportSettings/ReportSubSectionMappingUpdateAsync", postData).then(response => {
                    console.log(response.data)
                    this.snackbar = true
                    this.servicesData.message = "Sub section visibility updated successfully"
                })
            },
            dialogueClose() {

                this.$emit("formResponse", this.servicesData);
            },
            async formOption() {
                this.$forceUpdate()
                this.getHeaderOrder();
            },
            submit() {
                console.log(this.relsFiltered, this.formData.activeHeader)
            },
        }
    };
</script>

<style lang="scss" scoped>
    .hr-divider {
        width: 100%;
        max-width: 100%;
        border-width: 1px;
    }

    .order-item {
        padding: 1em;
        margin-top: 1em;
        background-color: $main-color;
        color: white;
    }
</style>
